import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GroupedComponents } from "../../components/GroupedComponents";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { OutagesCard, OutagesCardProps } from "../../components/OutagesCard";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface PowerOutagesPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  outageCards?: OutagesCardProps;
  lists?: GenericListProps[];
  faqs?: FaqAccordionGroupProps;
  linksList?: LinksProps[];
  processes?: ProcessStepsProps[];
}

export const PowerOutagesPage: React.FC<PowerOutagesPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  faqs,
  lists,
  outageCards,
  linksList,
  processes,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      </GroupedComponents>
      {outageCards && <OutagesCard {...outageCards} />}
      {paragraphs && paragraphs[2] && <Paragraph {...paragraphs[2]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {processes && processes[1] && <ProcessSteps {...processes[1]} />}
      {paragraphs && paragraphs[3] && <Paragraph {...paragraphs[3]} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
